// extracted by mini-css-extract-plugin
module.exports = {"free-html-content":"styles_free-html-content__mvkKb","paragraph-detail":"styles_paragraph-detail__fkzam"};